var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayicon = function SvgPlayicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.00586,228.01172a11.9889,11.9889,0,0,1-5.876-1.55664A11.85952,11.85952,0,0,1,68,215.98877V40.01123A12,12,0,0,1,86.25781,29.772l143.97656,87.98877h0a12.00023,12.00023,0,0,1,0,20.47852L86.25781,226.228A11.96075,11.96075,0,0,1,80.00586,228.01172Zm.01953-192.01611a4.13227,4.13227,0,0,0-1.98242.52685A3.92428,3.92428,0,0,0,76,40.01123V215.98877a3.99986,3.99986,0,0,0,6.08594,3.41309L226.0625,131.41309a4.00009,4.00009,0,0,0,0-6.82618L82.08594,36.59814A3.89956,3.89956,0,0,0,80.02539,35.99561Z"
  })));
};
export default SvgPlayicon;